import { queryKeys } from '@/src/api/queryKeys'
import { useLocationsContext } from '@/src/contexts/LocationsContext'
import { ONE_MINUTE_IN_MS } from '@/src/utils/constants'
import axios from '@api/axios_init'
import { useQuery } from '@tanstack/react-query'

const PRICES_URL = '/procurement/prices/electricity'

interface IProcurementKPI {
  currentYTDCost: number
  predictedYearEndCost: number
  currentEffectivePrice: number
}

interface IProcurementInfo {
  lastPriceUpdateAt: string
  kpis: IProcurementKPI
  avgSpotPrice: number
  spotShare: number
}

export const useProcurementInfo = () => {
  const { locations, selectedLocationIndex, isLocation, isInitialized } = useLocationsContext()
  const companiesWithMainDevices = (selectedLocationIndex === 0 ? locations : [locations?.[selectedLocationIndex]])
    ?.filter(l => l !== undefined && isLocation(l) && l.mainDevice)
    .map(loc => ({
      deviceId: loc?.mainDevice?.id,
      locationId: loc?.locationPgId,
      firebaseLocationId: loc?.id,
    }))

  const query = useQuery<IProcurementInfo | undefined>({
    queryKey: queryKeys.procurement.prices.manyByParams.toKeyWithArgs({ companiesWithMainDevices: companiesWithMainDevices || [] }),
    enabled: companiesWithMainDevices && companiesWithMainDevices.length > 0,
    staleTime: ONE_MINUTE_IN_MS * 15,
    gcTime: ONE_MINUTE_IN_MS * 15,
    queryFn: async () => {
      if (!companiesWithMainDevices?.length) return
      const { data } = await axios.post(PRICES_URL, { companiesWithMainDevices })
      const { kpis, avgSpotPrice, lastPriceUpdateAt, spotShare } = data

      return {
        lastPriceUpdateAt,
        kpis,
        avgSpotPrice,
        spotShare,
      }
    },
  })

  return query
}
